import { memo, useCallback, useEffect, useState } from "react";
import Script from "next/script";
import { AnimateCC, GetAnimationObjectParameter } from "react-adobe-animate";


interface Props {
  id: number ; 
  name: string; 
  animurl: string;
  // loaded: boolean;
  composition2: string; 
}

// const Canvas2Grid = ( {id, name, animurl, composition2 }: Props) => {
const Hw5Grid = memo(( {id, name, animurl, composition2 }: Props) => {
  const [areScriptsLoaded, setAreScriptsLoaded] = useState<string>("no");
  const [isCreateJSLoaded, setIsCreateJSLoaded] = useState(false);

  // const [animationFile, setAnimationFile] = useState(animacion.animurl);
  const [animationFile, setAnimationFile] = useState();
  const [animationObject, getAnimationObject] =
    useState<GetAnimationObjectParameter | null>(null);
  // const [animationObject, getAnimationObject] =
  //   useState(GetAnimationObjectParameter);
  const [paused, setPaused] = useState(false);
  // const [composition, setComposition] = useState<string>(composition2);
  const [composition, setComposition] = useState<string>(composition2);
  // const [composition, setComposition] = useState("");

  console.log("inicio del item animurl:" + animurl);

  const onReadyFunc = useCallback(() => {
    setAreScriptsLoaded("si");
    console.log(id+" 1r onReadyFunc areScriptsLoaded:" + areScriptsLoaded);
    console.log(id+" 2r onReadyFunc animationName={name}:"+name )  
    console.log(id+" 3r onReadyFunc composition={composition}:"+composition )  
    console.log(id+" 4r onReadyFunc getAnimationObject={animationObject}:"+animationObject )  
  }, [areScriptsLoaded]);

const onLoadFunc = useCallback(() => {
  setAreScriptsLoaded("si");
  console.log("1L onLoadFunc areScriptsLoaded:" + areScriptsLoaded);
  console.log("2L onLoadFunc animationName={name}:"+name )  
  console.log("3L onLoadFunc composition={composition}:"+composition )  
  console.log("4L onLoadFunc getAnimationObject={animationObject}:"+animationObject )  
}, [areScriptsLoaded]);

  const onErrorFunc = () => {
    console.log("Hw5Item Script onErrorFunc:" + animurl);
    //  setAreScriptsLoaded(true);
  };

const pr1 = () => {
  setAreScriptsLoaded("si");
  console.log("Boton pr1:");
};

const detalle = () => {
  // setAreScriptsLoaded("si");
  console.log("Boton Detalle:");
};

const debug1 = () => {
  console.log("onError debug1:")  
  console.log("onError animationName={name}:"+name )  
  console.log("onError composition={composition}:"+composition )  
  console.log("onError getAnimationObject={animationObject}:"+animationObject )  
};


  return (
    <>
        <>
          <Script
            src={animurl}
            type="text/javascript"
            // onReady={onScriptLoad}
            strategy="afterInteractive"
            onLoad={onLoadFunc}
            onReady={onReadyFunc}
            onError={onErrorFunc}
          />
        </>
      <li>
        <div className="hw5Grid-item">
          <div>        
            <button onClick={pr1}>pr1</button>
            <button onClick={detalle}>Det</button>
          </div>
          {/* <button onClick={() => handleDelete(user.id)}>
                 Delete ...
             </button> */}
          <div>
            <div className="row">
            {/* <div className="col-1">Id: {animacion.id}</div> */}
            <div className="col-1">Id: {id}</div>
            {/* <div className="col-2">name: {animacion.name}</div> */}
            <div className="col-2">name: {name}</div>
            </div>
            <div className="row">
            {/* <div className="col-1">animurl: {animacion.animurl}</div> */}
            <div className="col-1">animurl: {animurl}</div>
              <div className="col-2">areScriptsLoaded: {areScriptsLoaded}</div>
            </div>
          </div>
          <div className="hw5Grid-item-det1">
            {/* <LineChart /> */}
            Texto de prueba 1 
            {/* <div style={{ width: "200px" }} > */}
            <div style={{ width: "50%" }} >
            {/* <div style={{ height: "50%" }} > */}
              {/* {!areScriptsLoaded && "Loading scripts..."}
              {areScriptsLoaded && ( */}
              {areScriptsLoaded==="no" && "Loading scripts..."}
              {areScriptsLoaded==="si" && (
                  <AnimateCC
                  animationName={name}
                  composition={composition}
                  getAnimationObject={animationObject}
                  onError={() => debug1 }
                  paused={paused}
                />
                )}
            </div>
          </div>
        </div>
      </li>
    </>
  );
})
// );
// }

export default Hw5Grid;
